export function formatBillsIncluded(billsIncluded: string | string[]) {
    if (billsIncluded === 'true') {
        return 'Bills included';
    }

    return '';
}
